// extracted by mini-css-extract-plugin
export default {"hiperlink":"style_hiperlink__3h2Hc","historyHiperlink":"style_historyHiperlink__dF70f","linkReturnHistory":"style_linkReturnHistory__ydgmz","button":"style_button__Pgelc"};